import { createFileRoute } from '@tanstack/react-router'
import { ModuleGate } from '@/components/module-gate'

export const Route = createFileRoute('/_authed/reports')({
  component: () => (
    <ModuleGate moduleKey="reports">
      <Reports />
    </ModuleGate>
  ),
})

function Reports() {
  return (
    <div className="p-8">
      <h2 className="text-2xl font-bold">Reports</h2>
      <p className="mt-2 text-muted-foreground">Coming in Phase 1f.</p>
    </div>
  )
}
